const BANK_ACCOUNT_PARTNER_TYPE = {
	GREENDOT: 'greendot',
	STRIDE: 'core',
};
export default BANK_ACCOUNT_PARTNER_TYPE;
